export const filterColor = (value?: number) => {
    if (!value) {
        return 'default'
    }
    if (value > 0) {
        return 'green'
    }
    return 'red'
}


function processDot(num: number, precision: number) { //precision:保留小数位数
    return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
        precision,
    );
}
export const filterFormatThousandNumber = (number: number | null, n = 2) => {
    if (number == null || number == 0) {
        return "0.00"
    }
    let result = processDot(number, n).replace(/\d(?=(\d{3})+\.)/g, "$&,");

    const parts = result.split('.');

    if (parts.length === 1) return result; // 没有小数点，直接返回原字符串

    let integerPart = parts[0]; // 整数部分
    let decimalPart = parts[1].replace(/0*$/, ''); // 小数部分去掉末尾的0直至遇到第一个不为0的数为止

    // 如果处理后小数部分为空，则结果是小数点前的内容,两位小数
    if (decimalPart === '') {
        return integerPart + ".00";
    } else {
        return integerPart + '.' + decimalPart;
    }
}

export const filterFormatWanYiNumber = (value?: number | string, n = 2) => {
    if (value === undefined || value === null || value === '') {
        return '--'
    }

    const amount = Number(value)
    if (Number.isNaN(amount)) {
        return '--'
    }

    const absAmount = Math.abs(amount)
    const sign = amount < 0 ? '-' : ''

    if (absAmount >= 100000000) {
        return `${sign}${Number(processDot(absAmount / 100000000, n))}亿`
    }

    if (absAmount >= 10000) {
        return `${sign}${Number(processDot(absAmount / 10000, n))}万`
    }

    return `${sign}${filterFormatThousandNumber(absAmount, n)}`
}

export const filterFormatYiNumber = (value?: number | string, n = 2) => {
    if (value === undefined || value === null || value === '') {
        return '--'
    }

    const amount = Number(value)
    if (Number.isNaN(amount)) {
        return '--'
    }

    const absAmount = Math.abs(amount)
    const sign = amount < 0 ? '-' : ''

    return `${sign}${Number(processDot(absAmount / 100000000, n))}`
}

export const localToUTC = (localDate: Date | string) => {
    if (!localDate) return ""
    const date = new Date(localDate);
    const YYYY = date.getFullYear();
    const MM = (date.getMonth() + 1).toString().padStart(2, '0');
    const DD = date.getDate().toString().padStart(2, '0');
    return `${YYYY}-${MM}-${DD}`;
}

export const localToUTCHMS = (localDate: Date | string) => {
    if (!localDate) return ""
    const date = new Date(localDate);
    const YYYY = date.getFullYear();
    const MM = (date.getMonth() + 1).toString().padStart(2, '0');
    const DD = date.getDate().toString().padStart(2, '0');
    const HH = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    const SS = date.getSeconds().toString().padStart(2, '0');
    return `${YYYY}-${MM}-${DD} ${HH}:${mm}:${SS}`;
}

//数字大于0 ，前加“+” （盈亏、收益率。。。）

export const filterMoneyPlus = (m: number, t?: number, n = 2) => {
    let money = m
    if (t == 1) { //需要千分位的数据（例如：金额）
        money = Number(filterFormatThousandNumber(m, n))
    }
    return (Number(m) > 0 ? '+ ' : '') + money
}

export const filterFormatDate = (date: string | Date, days: number) => {
    if (date === '' || date == null) {
        return ''
    }

    const targetDate = new Date(date)
    if (Number.isNaN(targetDate.getTime())) {
        return ''
    }

    targetDate.setDate(targetDate.getDate() - days)

    const YYYY = targetDate.getFullYear()
    const MM = (targetDate.getMonth() + 1).toString().padStart(2, '0')
    const DD = targetDate.getDate().toString().padStart(2, '0')

    return `${YYYY}-${MM}-${DD}`
}

export const filterDiffDays = (startDate: string | Date, endDate: string | Date) => {
    if (startDate === '' || startDate == null || endDate === '' || endDate == null) {
        return 0
    }

    const start = new Date(startDate)
    const end = new Date(endDate)

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        return 0
    }

    const startAtMidnight = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime()
    const endAtMidnight = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime()
    const ONE_DAY = 24 * 60 * 60 * 1000

    return Math.abs(Math.round((endAtMidnight - startAtMidnight) / ONE_DAY))
}

export function uniqueObjArr<T extends Record<string, any>, K extends keyof T>(arr: T[], key: K): T[] {
    const map = new Map<T[K], boolean>();
    return arr.filter(item => {
        const val = item[key];
        if (map.has(val)) return false;
        map.set(val, true);
        return true;
    });
}
